<template>
  <div class="edit">
    <div class="edit_top">
      <div></div>
    </div>
    <div class="profile">
      <div class="profile_top">
        <div class="date_of_last_update">
          {{ dateOfLastUpdate }}
        </div>
      </div>
      <div class="profile_bottom">
        <div class="operation">
          {{ operation }}
        </div>
        <div class="operation_user">
          {{ operationUser }}
        </div>
        <div class="level">
          {{ level }}
        </div>
        <div class="log_Level">
          {{ logLevel }}
        </div>
        <div class="type">
          {{ type }}
        </div>
        <div class="log_type">
          {{ logType }}
        </div>
        <div class="log">
          {{ log }}
        </div>
        <div class="log_detail">
          {{ logDetail }}
        </div>
        <div class="target">
          {{ target }}
        </div>
        <div class="target_user">
          {{ targetUser }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      edit: '編集',
      dateOfLastUpdate: '2018/8/23/ 12:51:03',
      operation: '操作ユーザ',
      operationUser: 'CR06E201-002',
      level: 'ログレベル',
      logLevel: 'WARN',
      type: 'ログ種別',
      logType: 'システム操作',
      log: '監査ログ詳細',
      logDetail: 'ユーザ情報を編集しました',
      target: '対象ユーザ:admin',
      targetUser: '001 対象:パスワード変更'
    }
  }
}
</script>

<style scoped>
.edit {
  float: left;
  width: 29.7%;
  height: 100%;
  font-size: 14px;
  color: #5fc985;
  border-right: 1px solid #808080;
}
.edit_top {
  width: 100%;
  height: 6%;
  text-align: right;
  background-color: #daf8f3;
  border-bottom: 1px solid #808080;
  display: table;
}
.edit_top div {
  padding-right: 5%;
  text-decoration: none;
  display: table-cell;
  vertical-align: middle;
}
.edit_top .router {
  color: #39a196;
  text-decoration: none;
}
/*profile----------------------------------------*/
.profile {
  float: left;
  display: inline-block;
  width: 100%;
  font-size: 14px;
  text-align: left;
  color: #888;
  margin: 0;
  padding: 0;
}
/*profile_top--------------------------------------*/
.profile .profile_top {
  padding: 30px;
  font-size: 24px;
  color: #000;
  border-bottom: 1px solid #808080;
}
/*profile_bottom----------------------------*/
.profile_bottom {
  padding: 30px;
  font-size: 20px;
  color: #000;
}
.profile_bottom div:nth-child(odd) {
  font-size: 14px;
  padding-bottom: 6px;
  color: #888;
}
.profile_bottom div:nth-child(even):not(.log_type) {
  padding-bottom: 18px;
}
.profile_bottom .log_type {
  padding-bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/auditLoggings/auditLoggingDetail.vue